export default "__VITE_ASSET__DuND0PGo__"